import { TFunction } from 'i18next';
import { Run, Task } from '@bringg/types';
import { EtaResponseType } from '@bringg-frontend/eta-calculator';

import { OptimizationData } from '../../routes-planner-modal-types';
import { runNameProvider } from '../../../../services/runs/run-name-provider';

const convert = (
	runId: number,
	run: Run,
	optimizationData: OptimizationData[],
	task: Task,
	isManualOptimization: boolean,
	t: TFunction
) => {
	const runName = runNameProvider.get(run || ({ id: runId } as Run), isManualOptimization, t);
	const taskOptimizationData = optimizationData?.find(data => {
		return data.task_id === task.id;
	});

	const routeIndex = taskOptimizationData ? taskOptimizationData.route_idx : runId;

	const foundRoute = optimizationData?.find(data => {
		return data.type === EtaResponseType.RouteInfo && data.route_idx === routeIndex;
	});

	const plannedRouteData = {
		id: runId,
		route_idx: routeIndex,
		title: runName,
		transport_distance: foundRoute?.transport_distance || run?.planned_transport_distance,
		transport_time: foundRoute?.transport_time || run?.planned_transport_time_minutes,
		vehicle_id: Number(foundRoute?.power_unit_id) || run?.vehicle_id,
		task_ids: run?.task_ids || [],
		user_id: foundRoute?.user_id || run?.user_id,
		depot_etl: foundRoute?.depot_etl || Date.parse(run?.started_at || run?.scheduled_start_time) / 1000,
		depot_back_eta: foundRoute?.depot_back_eta || Date.parse(run?.ended_at || run?.scheduled_end_time) / 1000,
		started_at: run?.started_at,
		is_planned: run?.is_planned || !isManualOptimization
	};
	if (isManualOptimization) {
		Object.assign(plannedRouteData, {
			max_weight: run?.max_weight,
			max_handling_units: run?.max_handling_units,
			weight_capacity: run?.weight_capacity,
			handling_units_capacity: run?.handling_units_capacity,
			dynamic_aggregated_weight: run?.dynamic_aggregated_weight,
			dynamic_aggregated_handling_units: run?.dynamic_aggregated_handling_units
		});
	}
	return plannedRouteData;
};
export const routesPlannerRunConverter = { convert };
